import { getInitialTravelerInfoContext } from "@apac/checkout";
import {
  type IContactInfo,
  ParentState,
  getCartInitialContext,
  getAirChfarInitialContext,
  getIntialWalletContext,
} from "@hopper-b2b/checkout";
import {
  type ISelectedTrip,
  type SessionInfo,
  SupportStatus,
  type TripDetails,
} from "@hopper-b2b/types";
import { getInitialRewardsPaymentContext } from "@hsbc/rewards";
import type { FlightMachineContext } from "@hsbc/types";
import { getInitialWalletPaymentContext } from "@hsbc/wallet";
import { SelectedStatus } from "@overrides/types";

export const getInitialFlightMachineContext =
  function (): FlightMachineContext {
    return {
      ...getCartInitialContext(),
      sessionInfo: {} as SessionInfo,
      flightSearch: {
        tripCategory: undefined,
        destination: null,
        origin: null,
        departureDate: null,
        returnDate: null,
        originCountryCode: "",
        destinationCountryCode: "",
        multicityRoutes: [],
      },
      flightShop: {
        tripDetails: {} as TripDetails,
        selectedTrip: {} as ISelectedTrip,
        shopPricingInfo: {
          fare: undefined,
        },
        departureLabel: "",
        returnLabel: undefined,
        airports: undefined,
        selectedMulticityTrips: [],
      },
      common: {
        tripPricing: undefined,
      },
      auth: {
        guestUser: {
          givenName: undefined,
          surname: undefined,
        },
      },
      featureFlags: {
        enableHFv2: true,
        enableCfarExerciseCore: true,
      },
      [ParentState.cancelForAnyReason]: {
        cfarQuoteId: undefined,
        cfarOffers: undefined,
      },
      [ParentState.cancelForAnyReasonV2]: {
        cfarQuoteId: undefined,
        cfarOffers: [],
        selectedOffer: { status: SelectedStatus.UNSELECTED },
        aggregatedShopTrackingProperties: undefined,
      },
      [ParentState.disruptionV1]: {
        providedOfferQuotes: [],
        selectedOfferQuote: undefined,
      },
      [ParentState.changeForAnyReason]: { ...getAirChfarInitialContext() },
      [ParentState.passengerInformation]: {
        addPassport: false,
        currentInfantId: undefined,
        currentUserPassenger: undefined,
        error: undefined,
        infantOnlyError: false,
        isValidated: false,
        numPassengerAlertDismissed: false,
        selectedLapInfantIds: [],
        selectedPassengerIds: [],
        userPassengers: [],
        visited: false,
      },
      [ParentState.contactInformation]: {
        contactInfo: {} as IContactInfo,
        visited: false,
      },
      [ParentState.travelerInformation]: getInitialTravelerInfoContext(),
      [ParentState.contactAndTravelerInformation]: {
        selectedTravelerIds: [] as Array<any>,
        travelers: [] as Array<any>,
        numTravellerAlertDismissed: false,
        visited: false,
        currentInfantId: undefined,
        selectedLapInfantIds: [],
        infantOnlyError: false,
        addPassport: false,
        isValidated: false,
      },
      [ParentState.passport]: {
        error: undefined,
      },
      [ParentState.seatSelection]: {
        selectedSeats: [],
        selectedSeatSegments: [],
        cheapestSeat: undefined,
        seatMapHtml: undefined,
        seatMapRequest: undefined,
        seatsInfo: undefined,
        seatMapAvailable: undefined,
        visited: false,
        skipSeatSelection: false,
      },
      [ParentState.review]: {
        visited: false,
      },
      [ParentState.awardsPayment]: { ...getInitialRewardsPaymentContext() },
      [ParentState.cardPayment]: {
        paymentMethods: [],
        selectedPaymentMethodId: undefined,
        spreedlyToken: undefined,
        error: undefined,
        visited: false,
        verifiedPaymentMethods: [],
      },
      [ParentState.bookingConfirmation]: {},
      [ParentState.applyFees]: {},
      [ParentState.priceDrop]: {
        candidateId: undefined,
      },
      [ParentState.vipSupport]: {
        supportStatus: SupportStatus.vip,
      },
      [ParentState.changeForAnyReasonDiscount]: {},
      [ParentState.wallet]: { ...getIntialWalletContext() },
      walletPayment: { ...getInitialWalletPaymentContext() },
    };
  };
